import Select, { SelectOption } from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import _ from 'lodash';
import { GetWorkerSkillsResult, WorkerSkillResponse } from '@scale/genai-data-service-client';

type Props = {
  onChange: (workerSkillId: string | undefined) => void;
  value: string | undefined;
  className?: string;
  disabled?: boolean;
};

const SelectWorkerSkill = ({ onChange, value, className, ...props }: Props) => {
  const fetchWorkerSkills = async () => {
    try {
      const response = await apiFetch<GetWorkerSkillsResult>(null, '/corp-api/worker-skills', {
        method: 'GET',
      });

      const options = (response?.workerSkills ?? []).map((ws: WorkerSkillResponse) => ({
        label: ws.name,
        value: ws.id,
      }));

      return { options };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return { options: [] };
    }
  };

  return (
    <Select
      className={className}
      onChange={(value: SelectOption | null) => {
        onChange(value?.value);
      }}
      value={value}
      defaultOptions
      cacheOptions
      loadOptions={_.throttle(fetchWorkerSkills, 500)}
      placeholder="Select worker skill"
      {...props}
    />
  );
};

export default SelectWorkerSkill;
